// extracted by mini-css-extract-plugin
export const closeButton = "square-close-button-module--closeButton--24z9k";